import { c as _c } from "react/compiler-runtime";
import { isString } from '@netpurpose/types';
import posthog from 'posthog-js';
import { useEffect } from 'react';
import { useLoggedIn } from '../useLoggedIn/useLoggedIn';
export const usePostHogUser = () => {
  const $ = _c(7);
  const {
    user
  } = useLoggedIn();
  const userId = user?.id;
  const userEmail = user?.email;
  const userName = `${user?.firstName} ${user?.lastName}`;
  const group = user?.groups?.[0];
  const groupId = group?.groupId;
  const groupName = group?.name ?? undefined;
  let t0;
  let t1;
  if ($[0] !== groupId || $[1] !== groupName || $[2] !== userEmail || $[3] !== userId || $[4] !== userName) {
    t0 = () => {
      if (!userId) {
        posthog.reset();
        return;
      }
      const emailDomain = isString(userEmail) ? userEmail.split("@")?.[1] || "" : "";
      const userIsNetPurposeEmployee = emailDomain === "netpurpose.com";
      const userIsCloudFactoryEmployee = emailDomain.includes("cloudfactory");
      const userProperties = userIsNetPurposeEmployee || userIsCloudFactoryEmployee ? {
        email: userEmail || "",
        name: userName
      } : {
        email: `<redacted>@${emailDomain}`,
        name: `User at ${emailDomain}`
      };
      posthog.identify(userId, userProperties);
      if (groupId) {
        posthog.group("account", groupId, groupName ? {
          name: groupName
        } : {});
      }
    };
    t1 = [userId, userEmail, userName, groupId, groupName];
    $[0] = groupId;
    $[1] = groupName;
    $[2] = userEmail;
    $[3] = userId;
    $[4] = userName;
    $[5] = t0;
    $[6] = t1;
  } else {
    t0 = $[5];
    t1 = $[6];
  }
  useEffect(t0, t1);
};